import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { cloneDeep } from 'lodash';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { azurePostgreSqlTableMetadata } from './azure-postgre-sql-table-metadata';

const azureHorizonDbBaseMetadata = cloneDeep(azurePostgreSqlTableMetadata);
if (Array.isArray(azureHorizonDbBaseMetadata.copySinkControls)) {
    azureHorizonDbBaseMetadata.copySinkControls.forEach((control) => {
        if (
            control.type === 'parameterizable' &&
            control.child.type === 'radio-switch' &&
            control.child.bind === 'writeMethod'
        ) {
            const upsertOption = control.child.options?.find((option) => option.value === 'Upsert');
            if (upsertOption) {
                upsertOption.disabled = false;
            }
        }
    });
}

// Azure HorizonDB is PostgreSQL wire-compatible, so its copy connector metadata mirrors the Azure
// Database for PostgreSQL table metadata. Only the dataset type, display name and supported linked
// service binding differ. Copy activity supports Upsert, while copy job remains restricted to
// full-copy (append) only for now.
export const azureHorizonDbTableMetadata: IDatasetTypeMetadata = {
    ...azureHorizonDbBaseMetadata,
    type: adfModelTypeMap.azureHorizonDb.datasetType,
    displayName: stringResources.AzureHorizonDB_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.azureHorizonDb.linkedServiceType],
    icon: {
        className: 'svg-i-100x100-azure_horizonDB'
    },
    versionConfig: undefined,
    defaultVersion: undefined,
    copyJob: {
        multipleQuery: true
    }
};
